import React from 'react';
import { 
  ArrowDownTrayIcon,
  EnvelopeIcon,
  ChevronLeftIcon,
  ChevronRightIcon
} from '@heroicons/react/24/outline';

export default function SalesEnquiries() {
  return (
    <div className="px-8 py-8 max-w-[1400px] mx-auto flex flex-col gap-6 pb-20">
      
      {/* Header */}
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-2">
        <div>
          <h1 className="text-[32px] font-extrabold text-slate-900 tracking-tight">Landing Page Enquiries</h1>
          <p className="text-[15px] text-slate-500 mt-1 font-medium">
            Manage inbound interest and website form submissions.
          </p>
        </div>
        <div className="flex items-center gap-3">
          <button className="flex items-center gap-2 bg-white border border-slate-200 text-slate-700 px-5 py-2.5 rounded-xl text-sm font-bold hover:bg-slate-50 transition-colors shadow-sm">
            <ArrowDownTrayIcon className="w-4 h-4 text-slate-500" /> Export
          </button>
          <button className="flex items-center gap-2 bg-brand-600 text-white px-5 py-2.5 rounded-xl text-sm font-bold hover:bg-brand-700 transition-colors shadow-sm shadow-brand-500/20">
            <EnvelopeIcon className="w-4 h-4" /> Broadcast Email
          </button>
        </div>
      </div>

      {/* Tabs & Stats */}
      <div className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 border-b border-slate-200 pb-px mb-2">
        <div className="flex items-center gap-8">
          <button className="text-[14px] font-extrabold text-brand-600 border-b-2 border-brand-600 pb-4 px-1">
            All Submissions
          </button>
          <button className="text-[14px] font-bold text-slate-500 hover:text-slate-900 transition-colors pb-4 px-1">
            Unread
          </button>
          <button className="text-[14px] font-bold text-slate-500 hover:text-slate-900 transition-colors pb-4 px-1">
            Replied
          </button>
        </div>
        <div className="flex items-center gap-6 pb-4">
          <div className="flex items-center gap-2 text-[13px] font-bold text-slate-700">
            <div className="w-2.5 h-2.5 rounded-full bg-brand-500"></div>
            24 New Enquiries
          </div>
          <div className="flex items-center gap-2 text-[13px] font-bold text-slate-500">
            <div className="w-2.5 h-2.5 rounded-full bg-slate-300"></div>
            158 Total Month-to-Date
          </div>
        </div>
      </div>

      {/* Enquiries List */}
      <div className="bg-white border border-slate-200 rounded-[24px] shadow-sm flex flex-col overflow-hidden">
        
        {/* Table Header */}
        <div className="grid grid-cols-12 px-8 py-5 bg-slate-50/50 border-b border-slate-100 text-[11px] font-extrabold text-slate-400 uppercase tracking-widest">
          <div className="col-span-4">Sender & Company</div>
          <div className="col-span-5">Inquiry Message</div>
          <div className="col-span-2">Submitted</div>
          <div className="col-span-1 text-right">Actions</div>
        </div>

        {/* List Body */}
        <div className="flex flex-col divide-y divide-slate-100">
          
          {/* Row 1 */}
          <div className="grid grid-cols-12 items-center px-8 py-6 hover:bg-slate-50/50 transition-colors cursor-pointer">
            <div className="col-span-4 flex items-center gap-4 pr-6">
              <div className="w-12 h-12 rounded-full bg-blue-50 text-brand-600 font-extrabold flex items-center justify-center shrink-0 text-[15px]">
                AT
              </div>
              <div>
                <h4 className="text-[15px] font-bold text-slate-900 mb-0.5 leading-tight">Alex Thompson</h4>
                <p className="text-[12px] text-slate-500 mb-1 leading-none">alex.t@globallogistics.com</p>
                <p className="text-[10px] font-extrabold text-brand-600 uppercase tracking-widest leading-none mt-1.5">Global Logistics Inc.</p>
              </div>
            </div>
            <div className="col-span-5 pr-10">
              <h4 className="text-[14px] font-bold text-slate-900 mb-1 leading-tight">Pricing for Enterprise License</h4>
              <p className="text-[13px] text-slate-500 leading-snug line-clamp-2">
                We are looking to scale our operations to 500+ users across three regions. Can you provide a detailed...
              </p>
            </div>
            <div className="col-span-2">
              <p className="text-[13px] font-bold text-slate-900 mb-0.5">Oct 24, 2023</p>
              <p className="text-[11px] font-medium text-slate-500">2:45 PM</p>
            </div>
            <div className="col-span-1 text-right">
              {/* Empty placeholder to match screenshot */}
            </div>
          </div>

          {/* Row 2 */}
          <div className="grid grid-cols-12 items-center px-8 py-6 hover:bg-slate-50/50 transition-colors cursor-pointer">
            <div className="col-span-4 flex items-center gap-4 pr-6">
              <div className="w-12 h-12 rounded-full bg-slate-200 overflow-hidden shrink-0">
                 <img src="https://i.pravatar.cc/150?img=47" alt="Avatar" className="w-full h-full object-cover" />
              </div>
              <div>
                <h4 className="text-[15px] font-bold text-slate-900 mb-0.5 leading-tight">Elena Rodriguez</h4>
                <p className="text-[12px] text-slate-500 mb-1 leading-none">elena@vertexmedia.co</p>
                <p className="text-[10px] font-extrabold text-slate-600 uppercase tracking-widest leading-none mt-1.5">Vertex Media Group</p>
              </div>
            </div>
            <div className="col-span-5 pr-10">
              <h4 className="text-[14px] font-bold text-slate-900 mb-1 leading-tight">API Integration Inquiry</h4>
              <p className="text-[13px] text-slate-500 leading-snug line-clamp-2">
                We're currently using a custom internal CRM. Does your platform support webhooks or a REST API for seamles...
              </p>
            </div>
            <div className="col-span-2">
              <p className="text-[13px] font-bold text-slate-900 mb-0.5">Oct 23, 2023</p>
              <p className="text-[11px] font-medium text-slate-500">11:12 AM</p>
            </div>
            <div className="col-span-1 text-right">
            </div>
          </div>

          {/* Row 3 */}
          <div className="grid grid-cols-12 items-center px-8 py-6 hover:bg-slate-50/50 transition-colors cursor-pointer">
            <div className="col-span-4 flex items-center gap-4 pr-6">
              <div className="w-12 h-12 rounded-full bg-slate-100 border border-slate-200 text-slate-500 font-extrabold flex items-center justify-center shrink-0 text-[15px]">
                MR
              </div>
              <div>
                <h4 className="text-[15px] font-bold text-slate-900 mb-0.5 leading-tight">Marcus Reed</h4>
                <p className="text-[12px] text-slate-500 mb-1 leading-none">m.reed@techflow.io</p>
                <p className="text-[10px] font-extrabold text-slate-600 uppercase tracking-widest leading-none mt-1.5">Techflow Systems</p>
              </div>
            </div>
            <div className="col-span-5 pr-10">
              <h4 className="text-[14px] font-bold text-slate-900 mb-1 leading-tight">Demo Request for HR Team</h4>
              <p className="text-[13px] text-slate-500 leading-snug line-clamp-2">
                Hi, I saw your feature list on the landing page. Could we schedule a 15-minute demo specifically focused on th...
              </p>
            </div>
            <div className="col-span-2">
              <p className="text-[13px] font-bold text-slate-900 mb-0.5">Oct 22, 2023</p>
              <p className="text-[11px] font-medium text-slate-500">09:05 AM</p>
            </div>
            <div className="col-span-1 text-right">
            </div>
          </div>

        </div>

        {/* Pagination Footer */}
        <div className="px-8 py-5 border-t border-slate-100 flex items-center justify-between bg-slate-50/30">
          <span className="text-[13px] font-medium text-slate-500">
            Showing 1 to 3 of 24 submissions
          </span>
          <div className="flex items-center gap-2">
            <button className="w-8 h-8 rounded-lg flex items-center justify-center text-slate-400 hover:bg-slate-100 transition-colors">
              <ChevronLeftIcon className="w-4 h-4" />
            </button>
            <button className="w-8 h-8 rounded-lg flex items-center justify-center text-slate-600 hover:bg-slate-100 transition-colors">
              <ChevronRightIcon className="w-4 h-4" />
            </button>
          </div>
        </div>

      </div>
    </div>
  );
}